import { render, staticRenderFns } from "./radio.vue?vue&type=template&id=4c8859d4&scoped=true&"
import script from "./radio.vue?vue&type=script&lang=js&"
export * from "./radio.vue?vue&type=script&lang=js&"
import style0 from "./radio.vue?vue&type=style&index=0&id=4c8859d4&scoped=true&lang=scss&"
import style1 from "./radio.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8859d4",
  null
  
)

export default component.exports